<script setup lang="ts">
  import VgsDrawer from '@/components/common/VgsDrawer.vue'
  import Typography from '@/components/common/Typography.vue'
  import RichTextRenderer from '@/components/common/RichTextRenderer.vue'
  import { ref } from 'vue'
  import { useI18n } from 'vue-i18n'

  defineProps<{
    contentId: string
    explanation: string
  }>()

  const { t } = useI18n()
  const isOpen = ref<boolean>(false)
</script>

<template>
  <button
    data-track="begrepsforklaring-knapp"
    @click="isOpen = !isOpen"
  >
    <slot />
  </button>
  <VgsDrawer
    :open="isOpen"
    @close="isOpen = false"
  >
    <Typography variant="label">
      {{ t('explanation') }}
    </Typography>
    <RichTextRenderer :rich-text="explanation" />
  </VgsDrawer>
</template>

<style scoped>
  button {
    position: relative;
    background: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
    padding: 0;
    color: var(--color-red-30);

    &:focus-visible {
      outline: var(--color-red-30) auto 2px;
      outline-offset: 3px;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 100%;
      height: 2px;
      border-top: 2px dashed var(--color-red-30);
    }
  }
</style>
